import { DialogTitle, Typography } from '@mui/material';

export interface DualTitleDialog {
	dialogTitle: string;
	dialogTitleSecondary: string;
}
export const DualTitleDialog = ({ dialogTitle, dialogTitleSecondary }: DualTitleDialog) => {
	return (
		<DialogTitle fontSize={16}>
			{dialogTitle}
			<Typography variant='h5'>{dialogTitleSecondary}</Typography>
		</DialogTitle>
	);
};
